export default __webpack_public_path__ + "f346441db24202717aa072bec16bc705.jpg";